<template>
    <div id="app">
        <modal :showDialog="activeModal == 'EDITPROFILE'"  @close="() => activeModal = 'NONE'" :title="$t('EditProfile')">
            <edit-profile @cancel="activeModal = 'NONE'" @save="activeModal = 'NONE'" style="width: 25vw; overflow-y: scroll;"/>
        </modal>
        <div>
            <div class="top-logo-bar" style="display: grid; grid-template-columns: 60% 40%; align-items: center;" >
                <div style="display: flex; justify-content: flex-start;">
                    <div style="margin-left: 15px; cursor: pointer;">
                        <img src="~@/assets/img/_old/Menu.png" @click="menuVisible = !menuVisible"/>
                    </div>
                    <router-link :to="{name: 'systems'}">
                        <img class="app-logo" src="~@/assets/img/Menu/Logo.svg" style="margin-left:40px; height:35px; margin-top:0px;"/>
                    </router-link>
                    <div v-if="isSystem && !$store.getters.isMobile" style="font-size: 22px; display: flex; border-left: 1px solid white; padding-left: 20px; margin-left: 20px">
                        <span style="color: white;">{{ $route.params.systemName }}</span>
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end; height: 100%">
                    <div style="display: flex;">
                        <select class="language-selector" v-model="selectedLanguage" @change="changeLanguage">
                            <option :value="'English'">🇬🇧 English</option>
                            <option :value="'Polish'">🇵🇱 Polski</option>
                            <!-- <option :value="'Norwegian'">🇳🇴 Norsk</option> -->
                            <!-- <option :value="'Translation'">Translation</option> -->
                        </select>
                    </div>
                    <div class="horizontal top-bar-user-container" style="align-items: center; margin-right: 10px;" @mouseover="isProfileMenuVisible = true" @mouseleave="isProfileMenuVisible = false">
                        <img :src="getAvatar()" style="width: 34px; height: 34px; border-radius: 50%; margin-right: 10px;"/>
                        <div class="vertical grow" style="color: white; font-size: 14px;">
                            <div style="font-weight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                {{
                                    (user != null && user.fullName != undefined && user.fullName.trim() != '')
                                    ? user.fullName
                                    : $t('Anonymous')
                                }}
                            </div>
                            <div>
                                {{ (user != null && user.roles[0] != undefined) ? $t(user.roles[0]) : $t('NoRole') }}
                            </div>
                        </div>

                        <div v-if="isProfileMenuVisible" class="profile-menu vertical" >
                            <div class="horizontal grow profile-menu-row" @click="editProfile">
                                <img src="~@/assets/img/Menu/Profile.svg" class="profile-menu-img"/>
                                <div style="margin: auto;">{{ $t('Profile') }}</div>
                            </div>
                            <div class="horizontal grow profile-menu-row" @click="logout">
                                <img src="~@/assets/img/Menu/LogOut.svg" class="profile-menu-img"/>
                                <div style="margin: auto;">{{ $t('Logout') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="horizontal grow" style="max-width: 100vw; overflow: hidden;">
            <div>
                <NavigationMenu :absolute="menuAbsolute" :isVisible="menuVisible" :selectedLanguage="selectedLanguage" @changeLanguage="v => changeLanguage(_, v)"/>
            </div>
            <div class="main-router-view" id="main-router-view">
                <div class="mySpinner" v-if="$store.getters.isLoading">
                    <Spinner style="width: 100%; position: fixed; top: 50vh;"></Spinner>
                </div>
                <router-view class="scrollbar style-2" style="height: calc(100vh - 50px)"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import EditProfile from '@/components/Main/EditProfile.vue'
import Modal from '@/components/Modal.vue'
import IconButton from '@/components/IconButton'
import { getUserPhoto } from '@/api/api.js'
import Spinner from 'vue-simple-spinner'
import { setCulture } from '@syncfusion/ej2-base';
import NavigationMenu from '../components/Main/Menu/NavigationMenu.vue'

export default {
    components: {
      Modal,
      EditProfile,
      IconButton,
      Spinner,
      NavigationMenu
    },
    computed: {
        isSystem() {
            return this.$store.getters.systemId != null || this.$route.fullPath.includes('systemState')
        }
    },
    async mounted() {
        this.$root.$i18n.locale = this.$store.getters.language
        this.selectedLanguage = this.$store.getters.language
        this.user = this.$store.getters.user

        this.loadAvatar()

        this.$router.beforeEach((to, from, next) => {
            if(this.$store.getters.isMobile) {
                this.menuVisible = false;
            }
            next()
        })

        this.$nextTick(_ => {
            this.menuVisible = !this.$store.getters.isMobile
        })
    },
    data() {
        return {
            isProfileMenuVisible: false,
            user: null,
            activeModal: 'NONE',
            selectedLanguage: 'English',
            navigationMenu: [
                {
                    href: {name: 'systems'},
                    title: 'Systems',
                    icon: 'fa fa-user',
                    child: [
                        {
                            href: { name: 'map' },
                            title: 'Map'
                        },
                        {
                            href: { name: 'dashboard' },
                            title: 'Dashboard'
                        }
                    ]
                },
                {
                    href: { name: 'alarms' },
                    title: 'Alarms'
                },
                {
                    href: { name: 'visits' },
                    title: 'Service'
                },
                {
                    href: { name: 'users' },
                    title: 'Users',
                    child: [
                        {
                            href: { name: 'users' },
                            title: 'List'
                        },
                        {
                            href: {name: 'invitations'},
                            title: 'Invitations'
                        }
                    ]
                }
            ],
            menuVisible: false,
            menuAbsolute: false
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
               .then(() => this.$router.push('/'));
        },
        editProfile() {
            this.activeModal = 'EDITPROFILE'
        },
        async loadAvatar(){
            try {
                var response = await getUserPhoto(this.user.userId);
                this.photoData = response.data
                this.$store.dispatch('update_avatar', this.photoData);
            } catch (e) {

            }
        },
        getAvatar(){
            return this.$store.getters.avatar == null ? this.loadAvatar() : URL.createObjectURL(this.$store.getters.avatar)
        },
        changeLanguage(_, value) {
            // console.log(value)
            if(value != undefined && value != null) {
                this.selectedLanguage = value
            }
            this.$store.dispatch('change_language', this.selectedLanguage)
            setCulture(this.$root.$i18n.t('ej2LocaleCulture'));
            this.$root.$i18n.locale = this.selectedLanguage
            location.reload();
        }
  }
}
</script>

<style>
    .profile-modal {
        left: 50vw !important;
        top: 50vh !important;
    }
</style>

<style scoped>
span, p, h1, h2, h3, h4, h5 {
        color: #414F51;
    }

    .box {
        height: 850px;
    }

    .nav-bg {
        background-image: linear-gradient(rgb(50, 147, 160), rgb(53, 107, 136));
    }

    main {
        background-image: linear-gradient(to right, rgb(225, 239, 242), rgb(230, 245, 248));
    }

    header {
        background: white;
    }

    img {
        vertical-align: middle;
        display: inline-block;
    }

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .darkColor {
        color: rgb(65, 79, 81);
    }

    #menuCell {
        background: rgb(50, 147, 160);
    }

    .list-group {
        overflow-y: auto;
    }

    .list-group-item {
        background: transparent;
        border: 3px solid transparent;
        padding: 4px;
        width: 220px;
        align-items: flex-start;
        align-content: flex-start;
    }

    @media (max-width: 670px) {
        .language-selector {
            display: none;
        }

        .navbar-mobile {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            z-index: 100;
            padding-top: 92px;
        }

        .blur-mobile {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 99;
            background-color: rgba(50,147,160, 0.6);
        }
    }

    .list-group-item:hover, #menuCellHelper:hover {
        border-left: 3px solid white;
        border-right: 3px solid white;
    }

    .list-group-item:first-child {
        border-radius: 0;
    }

    .helper {
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }

    .top-bar-user-container {
        padding: 4px;
        height: 100%;
        /* transition-duration: 0.3s; */
        cursor: pointer;
    }

    .profile-menu {
        position: absolute;
        top: 50px;
        right: 0;
        min-width: 130px;
        color: white;
        background-color: #414F51;
        padding: 10px;
        z-index: 3;
    }

    .profile-menu-img {
        height:35px;
        margin-top:0px;
        padding:2px;
    }

    .profile-menu-row {
        justify-content: center;
        align-content: center;
        cursor: pointer;
    }

    .profile-menu-row:hover {
        background-color: #606b6d;
    }

    .selectedSystemsBackground {
      background-color: rgba(0, 125, 149, 1);
    }

    .main-router-view {
        background-color: #e5f4f7;
        width: 100%;
        overflow-x: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue